var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "buttons" }, [
    _c("div", { staticClass: "buttons__left" }, [
      _c("div", { staticClass: "buttons__chevron" }, [_c("ChevronIcon")], 1),
      _c(
        "div",
        [
          _c("AudioIcon", {
            on: {
              toggleSound: function ($event) {
                return _vm.$emit("toggleSound")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }